export { CardDetailsView } from './CardDetailsView.ui';
